import { Component } from 'react';

import DOMPurify from 'dompurify';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';

import * as E from './styles';

// Default avatar image
const defaultAvatar = '/assets/images/avatar.png';

class JChatBox extends Component {
  render() {
    const { profile, message, theme } = this.props;
    const _isBorderRadius = this.props.float;
    const _borderRadiusStyleChat = {
      borderBottomLeftRadius: _isBorderRadius ? 7.5 : 0,
      borderBottomRightRadius: _isBorderRadius ? 0 : 7.5
    };
    const imageReplaced = !!(message?.body) ? message.body.replace(/\[image\]/gi, '') : null;

    return (
      <ThemeProvider theme={{ name: this.props.theme }}>
        <E.Container float={this.props.float}>
          <div>
            {(message?.files && message.files.length) 
              ? message.files.filter(file => file.url).map((file, idx) => (
                  <E.ImageInlineContainer key={`image-inline-${idx}`} onClick={() => this.props.onShowModal && this.props.onShowModal(file.url)}>
                    <E.ImageInline src={file.url} width={50} />
                  </E.ImageInlineContainer>
                )) 
              : null}
          </div>
          {imageReplaced && (
            <E.Inner style={_borderRadiusStyleChat}>
              <E.Text dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(imageReplaced) }} />
            </E.Inner>
          )}
          {this.props.profile && (
            <E.Profile float={this.props.float}>
              <E.Name>{profile.username || (profile.first_name + ' ' + profile.last_name)}</E.Name>
              <E.WrapAvatar>
                <E.Avatar>
                  <E.AvatarImage src={profile.photo ? profile.photo : defaultAvatar} />
                </E.Avatar>
                {message?.ts && <E.TS>{moment(message.ts).format("hh:mm")}</E.TS>}
              </E.WrapAvatar>
            </E.Profile>
          )}
        </E.Container>
      </ThemeProvider>
    );
  }
}

JChatBox.propTypes = {
  theme: PropTypes.string,
  float: PropTypes.bool
};

JChatBox.defaultProps = {
  theme: 'quest',
  float: false
};

export default JChatBox;

